<script setup>
import { tableRecipe } from './table.recipe';
import { useTableContext } from './useTable';

/**
 * @typedef {import('./table.recipe').TableRecipeVariants} TableRecipeVariants
 */

/**
 * @typedef {object} TablePaginationContainerProps
 * @property {TableRecipeVariants['variantBg']} [variantBg='surface'] - The background variant of the table pagination container.
 */
const props = defineProps({
  variantBg: {
    type: String,
    default: 'surface',
  },
});

const { paginationContainer } = tableRecipe();
const { rootProps } = useTableContext();
</script>

<template>
  <div
    data-component="CsTablePaginationContainer"
    :class="paginationContainer({ ...props, ...rootProps })"
  >
    <slot />
  </div>
</template>
